<template>
  <div class="signup">
    <div class="title">
      <h8>Welcome to Pair'd</h8>
    </div>

    <br> 

    <div class="slack_account">
      <b-form-fieldset 
      description="Link it to your Slack account."
      label="Enter your Slack account"
      :feedback="feedback_slack" 
      :state="state_slack"
      :label-cols="3"
      >
        <b-form-input v-model="slack" :state="state"></b-form-input>
      </b-form-fieldset>  
    </div> 

    <div class="profile_name">
      <b-form-fieldset 
      description="Choose your own nickname."
      label="Enter your profile name"
      :feedback="feedback_pname" 
      :state="state_pname"
      :label-cols="3"
      >
        <b-form-input v-model="pname" :state="state"></b-form-input>
      </b-form-fieldset>  
    </div> 

    <div class="password_prompt">
      <h8>Enter your password </h8>
    </div>

    <div class="VuePassword" :title="feedback_password">
      <div class="VuePassword__Input">
        <input type="password"
                :name="name"
                :placeholder="placeholder"
                :id="id"
                :class="classes"
                :value="value"
                :minlength="minlength"
                :maxlength="maxlength"
                :required="required"
                :pattern="pattern"
                ref="input"
                @input="updatePassword($event.target.value)"
        >

        <slot name="password_toggle" v-if="!disableToggle" :toggle="togglePassword" :type="type">
          <a class="VuePassword__Toggle" role="button" @click="togglePassword">
            <svg class="VuePassword__Toggle__Icon" viewBox="0 0 32 32" v-if="type === 'password'">
              <path d="M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228v0zM16 13c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"></path>
            </svg>
            <svg class="VuePassword__Toggle__Icon" viewBox="0 0 32 32" v-if="type === 'text'">
              <path d="M29.561 0.439c-0.586-0.586-1.535-0.586-2.121 0l-6.318 6.318c-1.623-0.492-3.342-0.757-5.122-0.757-6.979 0-13.028 4.064-16 10 1.285 2.566 3.145 4.782 5.407 6.472l-4.968 4.968c-0.586 0.586-0.586 1.535 0 2.121 0.293 0.293 0.677 0.439 1.061 0.439s0.768-0.146 1.061-0.439l27-27c0.586-0.586 0.586-1.536 0-2.121zM13 10c1.32 0 2.44 0.853 2.841 2.037l-3.804 3.804c-1.184-0.401-2.037-1.521-2.037-2.841 0-1.657 1.343-3 3-3zM3.441 16c1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 1.715 0.54 3.304 1.459 4.607l-1.904 1.904c-1.639-1.151-3.038-2.621-4.114-4.323z"></path>
              <path d="M24 13.813c0-0.849-0.133-1.667-0.378-2.434l-10.056 10.056c0.768 0.245 1.586 0.378 2.435 0.378 4.418 0 8-3.582 8-8z"></path>
              <path d="M25.938 9.062l-2.168 2.168c0.040 0.025 0.079 0.049 0.118 0.074 1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303-1.208 0-2.403-0.149-3.561-0.439l-2.403 2.403c1.866 0.671 3.873 1.036 5.964 1.036 6.978 0 13.027-4.064 16-10-1.407-2.81-3.504-5.2-6.062-6.938z"></path>
            </svg>
          </a>
        </slot>  

      </div>  
    </div> 

    <div class="password_confirm">
      <b-form-fieldset 
      label="Confirm your password"
      :feedback="feedback_confirm" 
      :state="state_confirm"
      :label-cols="3"
      >
        <b-form-input v-model="confirm" :state="state"></b-form-input>
      </b-form-fieldset>  
    </div> 

    <div class="dietary">
      <h8> Dietary Options </h8>
      <br> 
      <div class="options"> 
        <b-form-radio v-model="selected" 
        :options="options" 
        :feedback="feedback_dietary"
        :state="state_dietary"> 
        </b-form-radio>
      </div>
      <br> 
    </div>

    <div class="signup_button hvr-grow">
      <b-button size="big" variant="outline-success" href="">
        Sign Up
      </b-button>
    </div> 
    
    <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br> <br>

  </div>
</template>


<script>
/* var Form1 = document.getElementById('Form1') */

export default {
  computed: {
    feedback_slack () {
      return this.slack.length ? '' : 'Invalid'
    },
    feedback_pname () {
      return this.pname.length ? '' : 'Invalid'
    },
/*     feedback_password () {
      return this.password.length ? '' : 'Invalid'
    }, */
    feedback_confirm () {
      return this.confirm.length ? '' : 'Invalid'
    },
    feedback_dietary () {
      return this.selected.length ? '' : 'Invalid'
    },
    state_slack () {
      return this.slack.length ? 'success' : 'warning'
    },
    state_pname () {
      return this.pname.length ? 'success' : 'warning'
    },
    state_password () {
      return this.password.length ? 'success' : 'warning'
    },
    state_confirm () {
      return this.confirm.length ? 'success' : 'warning'
    },
    state_dietary () {
      return this.selected.length ? 'success' : 'warning'
    }
  },
  data () {
    return {
      slack: '',
      pname: '',
      password: '',
      confirm: '',
      type: 'password',
      dirty: false,
      selected: 'first',
      options: [{
        text: 'Vegeterian',
        value: 'first'
      }, {
        text: 'Vegan',
        value: 'second'
      }]
    }
  },
  methods: {
      /**
       * Update the password input.
       *
       * @param  {String} password
       */
    updatePassword (password) {
      this.$emit('input', password)
      this.dirty = true
    },
      /**
       * Toggle the visibilty of the password.
       */
    togglePassword () {
      this.type = this.type === 'password' ? 'text' : 'password'
      this.$refs.input.setAttribute('type', this.type)
      this.$refs.input.focus()
    },
      /**
       * Get the current strength class based on the strength calculated
       * by zxcvbn.
       *
       * @param  {Number} strength
       * @return {String}
       */
    getStrengthClass (strength) {
      if (this.strength.score > strength) {
        return this.strengthClass
      }
      return ''
    }
  }

}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
@import './../assets/hover-min.css';

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.signup {
  display: inline-block;
  position: relative;
}
.signup::before {
  content: "";
  display: block;
  position:absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  background: url("./../assets/signup-5.jpeg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  opacity: 0.8;
}

.title {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-style: oblique;
  font-size: 60px;
  text-align: center;
  color: black;
  margin-top: 30px;
}

.slack_account {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  position: relatives;
  margin-left: 600px;
  margin-right: 600px;
}

.profile_name {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  position: relatives;
  margin-left: 600px;
  margin-right: 600px;
}

.password_prompt {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  color:rgb(240, 173, 79);
  position: relatives;
  margin-left: 600px;
  margin-right: 600px;
}

.VuePassword {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 25px;
  position: relatives;
  margin-left: 600px;
  margin-right: 600px;
}

  .VuePassword__Input {
    position: relative;
  }
  .VuePassword input {
    padding-right: 2.5em;
    width: 100%;
  }
  .VuePassword__Toggle {
    color: gray;
    display: inline-block;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
  .VuePassword__Toggle__Icon {
    fill: currentColor;
    height: 100%;
    width: 1.5em;
    margin-right: .5em;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
  }
  
  .VuePassword__Message {
    cursor: default;
    font-size: 1rem;
    padding-left: .5rem;
    padding-right: .5rem;
    text-align: right;
    text-transform: uppercase;
  }

.password_confirm {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  position: relatives;
  margin-top: 20px;
  margin-left: 600px;
  margin-right: 600px;
}

.dietary {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  color:rgb(240, 173, 79);
  position: relatives;
  margin-left: 600px;
  margin-right: 600px;
}

.options {
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 20px;
  color:rgb(240, 173, 79);
  position: relatives;
  margin-top: 20px;
  margin-left: 100px;
}

.signup_button {
  position: relatives;
  margin-left: 800px;
  margin-right: 800px;
}

</style>


// WEBPACK FOOTER //
// signup.vue?3ae37702